import {arrays, sorting, strings} from "@atttomyx/shared-utils";
import {RANKS} from "../constants";

const renderOne = (key) => {
    return RANKS[key];
};

const renderMultiple = (keys) => {
    let rendered = keys.length === 0 ? "None" : "";

    if (keys.length > 0) {
        const labels = [];

        keys.forEach((key) => {
            arrays.addTo(labels, renderOne(key));
        });

        rendered = strings.commaSeparated(labels.sort(sorting.alphabetize));
    }

    return rendered;
};

export const renderRanks = (oneOrMore) => {
    return Array.isArray(oneOrMore)
        ? renderMultiple(oneOrMore)
        : renderOne(oneOrMore);
};
